import createRangeSelectFilter from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/RangeSelectFilter/factory";

import { DOLLAR_PREFIX } from "../../constants/index";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { formatMoney } from "../../utils/numberFormatters";
import { defineDescriptionFilter } from "../defineSourcedFilter";

export const annualRevenueDefinition = defineDescriptionFilter({
    key: "annualRevenue",
    apiCategory: leadsFilterApiCategory.annualRevenue,
    category: leadsFilterCategoryMap.company,
    trackingName: "Annual Revenue (USD)",

    render: ({ description }) =>
        createRangeSelectFilter({
            key: "annualRevenue",
            trackingName: "Annual Revenue (USD)",
            apiCategory: leadsFilterApiCategory.annualRevenue,
            category: leadsFilterCategoryMap.company,

            translationKey: "annual_revenue",
            rangeOptions: {
                fieldName: "annualRevenue",
                buckets: description.bucketsDescription.annualRevenue,
                placeholderPrefix: DOLLAR_PREFIX,
                formatValue: formatMoney,
            },
        }),
});
